import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PatientDetailComponent } from '../patient-detail.component';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AllowOnlyDigitsDirective } from 'src/app/common/directive/allow-only-digits.directive';
import { IPatientAddress, IPatientInfo } from '../../ipatient-info';

@Component({
  selector: 'app-contact-address',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    TablerIconsModule,
    TranslateModule,
    AllowOnlyDigitsDirective
  ],
  templateUrl: './address-detail.component.html',
  styleUrl: './address-detail.component.scss'
})
export class AddressDetailComponent implements OnInit, OnChanges {

  @Input() patient: IPatientInfo;
  @Input() patientForm!: FormGroup;
  contactForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<PatientDetailComponent>,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['patient'] && this.patient) {
      if (!this.patient.address || this.patient.address.length < 2) {
        this.patient.address = [
          this.patient.address[0] || this.createEmptyAddress(),
          this.patient.address[1] || this.createEmptyAddress()
        ];
      }
    }

  }

  ngOnInit(): void {
    if (!this.patient.address || this.patient.address.length < 2) {
      this.patient.address = [
        this.patient.address[0] || this.createEmptyAddress(),
        this.patient.address[1] || this.createEmptyAddress()
      ];
    }
  }

  createEmptyAddress(): IPatientAddress {
    return {
      id: 0,
      address1: '',
      address2: '',
      pincode: '',
      country: '',
      state: '',
      district: '',
      area: '',
      taluka: '',
    };
  }

  onSameAsAboutChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.patient.address[1] = {
        id: this.patient.address[1].id || 0,// id will same as id [1]
        address1: this.patient.address[0].address1,
        address2: this.patient.address[0].address2,
        pincode: this.patient.address[0].pincode,
        country: this.patient.address[0].country,
        state: this.patient.address[0].state,
        district: this.patient.address[0].district,
        area: this.patient.address[0].area,
        taluka: this.patient.address[0].taluka,
      };

    } else {
      this.patient.address[1] = {
        ...this.createEmptyAddress(),
        id: this.patient.address[1]?.id || 0
      };
    }
  }
}
